import { useState, useEffect } from "react";
import {
  loginAPI,
  sendForgotOtpAPI,
  verifyOtpAPI,
  resetPasswordAPI
} from "../../../api/auth_api";

export default function useLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const [showForgot, setShowForgot] = useState(false);
  const [step, setStep] = useState(1);

  const [fpEmail, setFpEmail] = useState("");
  const [fpOtp, setFpOtp] = useState("");
  const [fpNewPass, setFpNewPass] = useState("");
  const [fpConfirmPass, setFpConfirmPass] = useState("");

  const [processing, setProcessing] = useState(false);
  const [timer, setTimer] = useState(0);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  useEffect(() => {
    if (timer > 0) {
      const i = setInterval(() => setTimer(t => t - 1), 1000);
      return () => clearInterval(i);
    }
  }, [timer]);

  // ✅ Auto-dismiss error after 3 seconds
  useEffect(() => {
    if (!errorMsg) return;
    const t = setTimeout(() => setErrorMsg(""), 3000);
    return () => clearTimeout(t);
  }, [errorMsg]);

  // ✅ Auto-dismiss success message after 3 seconds
  useEffect(() => {
    if (!successMsg) return;
    const t = setTimeout(() => setSuccessMsg(""), 3000);
    return () => clearTimeout(t);
  }, [successMsg]);

  const formatTime = (sec) => {
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  };

  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true);

    try {
      const data = await loginAPI(email, password);
      setLoading(false);

      if (data.status === "success") {
        setShowSuccess(true);

        localStorage.setItem("user_name", data.user);
        localStorage.setItem("empID", data.empID);
        localStorage.setItem("designation", data.designation);
        localStorage.setItem("location", data.location);
        localStorage.setItem("email", email);
        localStorage.setItem("role", data.role);
        localStorage.setItem("userID", data.userID);
        localStorage.setItem("isLoggedIn", "true");

        setTimeout(() => (window.location.href = "/dashboard"), 1200);
      } else {
        setErrorMsg("Invalid credentials. Please check your email and password.");
      }
    } catch {
      setErrorMsg("Unable to reach server. Please try again.");
      setLoading(false);
    }
  }

  async function sendOtp() {
    if (!fpEmail) return setErrorMsg("Please enter your registered email.");
    setProcessing(true);

    const data = await sendForgotOtpAPI(fpEmail);
    setProcessing(false);

    if (data.status !== "success") return setErrorMsg(data.message || "Failed to send OTP. Try again.");

    setStep(2);
    setTimer(600);
  }

  async function verifyOtp() {
    if (!fpOtp) return setErrorMsg("Please enter the OTP sent to your email.");
    setProcessing(true);

    const data = await verifyOtpAPI(fpEmail, fpOtp);
    setProcessing(false);

    if (data.status !== "success") return setErrorMsg("Invalid OTP. Please try again.");

    setStep(3);
  }

  async function resetPassword() {
    if (!fpNewPass || !fpConfirmPass)
      return setErrorMsg("Please fill in both password fields.");

    if (fpNewPass !== fpConfirmPass)
      return setErrorMsg("Passwords do not match. Please try again.");

    setProcessing(true);

    const data = await resetPasswordAPI(fpEmail, fpOtp, fpNewPass);
    setProcessing(false);

    if (data.status !== "success")
      return setErrorMsg("Password reset failed. Please try again.");

    setSuccessMsg("Password reset successful! Please login.");
    setShowForgot(false);
    setStep(1);
  }

  return {
    email, setEmail,
    password, setPassword,
    loading, handleLogin,
    showSuccess,

    errorMsg, setErrorMsg,
    successMsg, setSuccessMsg,
    showForgot, setShowForgot,
    step, setStep,
    fpEmail, setFpEmail,
    fpOtp, setFpOtp,
    fpNewPass, setFpNewPass,
    fpConfirmPass, setFpConfirmPass,
    processing, timer, formatTime,
    sendOtp, verifyOtp, resetPassword,
  };
}